define('app/views/customer_profile_mobile_view',['app/setup'],
  function(takhfifan) {

  takhfifan.CustomerProfileMobileView = Backbone.View.extend({

    el: $('.tkh-customer-profile-mobile'),

    events: {
      'submit .tkh-customer-profile-mobile__phone-form': 'changeMobile',
      'submit .tkh-customer-profile-mobile__verify-form': 'verifyCode'
    },

    initialize: function(options) {
      this.verificationUrl = this.$el.data('verifyUrl');
      this.sendSMSUrl = this.$el.data('changeUrl');
      this.verificationModal = this.$('.tkh-customer-profile-mobile__verify-form');

      takhfifan.eventHub.on('modal:disableTriggerElement', function(options) {
        this.verificationModal.hide();
      }, this);
    },

    changeMobile: function(e){
      e.preventDefault(e);
      var _this = this,
          $form = $(e.target),
          phoneNumber = $form.find('input[name="mobile"]').val(),
          $inputWrapper = $form.find('.control-wrapper');

      if(!phoneNumber){
        $inputWrapper.addClass('error');
        var $errorEm = $('<em class="icon-error red tkh-error">لطفا شماره همراه خود را وارد کنید</em>');
        $inputWrapper.append($errorEm);
      }else{
        $inputWrapper.removeClass('error');
        $inputWrapper.find('.tkh-error').remove();
        $form.addClass('loading-view');
        $.ajax({
          url: $form.prop('action'),
          type: $form.prop('method'),
          data: {mobile: phoneNumber, form_key: takhfifan.formKey}
        }).done(function (data) {
          if (data.success) {
            takhfifan.eventHub.trigger('modal:showModalWithContent',
              {
                triggerElement:_this.verificationModal,
                fadeTimeIn:400,
                elementToOperate:_this.verificationModal
              });
            _this.phoneNumber = phoneNumber;
          } else {
            takhfifan.eventHub.trigger('message:show', {
              type: 'error',
              msg: "در برقراری ارتباط خطایی پیش آمد"
            });
          }
        }).fail(function () {
          takhfifan.eventHub.trigger('message:show', {
            type: 'error',
            msg: "در برقراری ارتباط خطایی پیش آمد"
          });
        }).always(function () {
          $form.removeClass('loading-view');
        });
      }

    },

    verifyCode: function(e) {
      e.preventDefault(e);
      var _this = this,
          $form = $(e.target),
          verificationCode = $form.find('input[name="code"]').val(),
          $inputWrapper = $form.find('.control-wrapper');

      if(!verificationCode){
        $inputWrapper.addClass('error');
        var $errorEm = $('<em class="icon-error red tkh-error">لطفا کد ارسال شده را وارد کنید</em>');
        $inputWrapper.append($errorEm);
      }else {
        $inputWrapper.removeClass('error');
        $inputWrapper.find('.tkh-error').remove();
        $form.addClass('loading-view');
        console.log(_this.phoneNumber);

        $.ajax({
          url: $form.prop('action'),
          type: $form.prop('method'),
          data: {
            mobile: _this.phoneNumber,
            code: verificationCode,
            form_key: takhfifan.formKey
          }
        }).done(function (data) {
          if (data.success) {
            takhfifan.eventHub.trigger('message:show', {
              type: 'success',
              msg: "شماره همراه شما با موفقیت تغییر کرد"
            });
          } else {
            takhfifan.eventHub.trigger('message:show', {
              type: 'error',
              msg: "در برقراری ارتباط خطایی پیش آمد"
            });
          }
        }).fail(function () {
          takhfifan.eventHub.trigger('message:show', {
            type: 'error',
            msg: "در برقراری ارتباط خطایی پیش آمد"
          });
        }).always(function () {
          $form.find('input[name="code"]').val('');
          $form.removeClass('loading-view');
          takhfifan.eventHub.trigger('modal:closeModalWithContent');
        });
      }
    }
  });

});

